import { IExercise, ExerciseData } from '../exercise';
import { PdfUnit, PdfFont, PdfBrush, ETextAlign } from '../../pdf/pdf';

export class ExeHeading implements IExercise {
  readonly name = 'Heading';
  readonly fixedHeight = PdfUnit.FromMillimeters(15);
  readonly noWindow = true;
  readonly injectEq = false;
  readonly injectAbc = false;

  draw(data: ExerciseData): void {
    const {text} = data.item;
    if (!text) return;

    const font = new PdfFont(PdfFont.FONT_NAME, 18);
    data.page.drawString(text, font, PdfBrush.Black, null, data.rect, ETextAlign.CenterLeft);
  }
}
